export default __webpack_public_path__ + "static/media/O3Labs.f7983a23.svg";